import React, { memo } from "react";
import ReactMarkdown from "react-markdown";

export const SAMTextMobile = memo(({ textes }) => {
  return (
    <section className="flex flex-col items-center justify-center min-h-screen p-4 bg-black">
      <div className="w-full max-w-md text-center">
        <div className="text-[clamp(4rem,20vw,4rem)] text-white font-bold mb-8">
          <ReactMarkdown
            escapeHtml={false}
            components={{
              strong: ({ node, ...props }) => (
                <span
                  className="text-[#00ffcc] font-bold"
                  style={{
                    fontSize: "inherit",
                  }}
                  {...props}
                />
              ),
            }}
          >
            {textes?.textScrolling.split("*")[0]}
          </ReactMarkdown>
        </div>
        <div className="text-[clamp(8rem,15vw,16rem)] text-white">
          <ReactMarkdown
            escapeHtml={false}
            components={{
              strong: ({ node, ...props }) => (
                <span
                  className="text-[#00ffcc] font-bold font-sam"
                  style={{
                    fontSize: "inherit",
                    width: "100%"
                  }}
                  {...props}
                />
              ),
            }}
          >
            {textes?.textScrolling.slice(
              textes?.textScrolling.split("*")[0].length
            )}
          </ReactMarkdown>
        </div>
      </div>
    </section>
  );
});

SAMTextMobile.displayName = "SAMTextMobile";

export default SAMTextMobile;
